import { PawPrint, Phone, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Navbar = () => {
  const scrollToChat = () => {
    window.dispatchEvent(new CustomEvent("open-chat"));
  };

  return (
    <nav
      data-testid="navbar"
      className="fixed top-0 left-0 right-0 z-40 bg-background/80 backdrop-blur-lg border-b border-border/40"
    >
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="/"
            data-testid="navbar-logo"
            className="flex items-center gap-2.5"
          >
            <div className="w-9 h-9 rounded-xl bg-primary flex items-center justify-center">
              <PawPrint className="w-5 h-5 text-primary-foreground" strokeWidth={2} />
            </div>
            <span className="font-bold text-lg text-foreground tracking-tight">
              Clínica Veterinaria Demo
            </span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            <a
              href="#servicios"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Servicios
            </a>
            <a
              href="#como-funciona"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              Cómo funciona
            </a>
            <a
              href="#faq"
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
            >
              FAQ
            </a>
          </div>

          <div className="flex items-center gap-3">
            <a
              href="tel:+34600000000"
              className="hidden sm:flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              <Phone className="w-4 h-4" strokeWidth={1.5} />
              <span>Llamar</span>
            </a>
            <Button
              data-testid="navbar-cta"
              onClick={scrollToChat}
              className="rounded-full px-5 h-9 text-sm font-medium bg-primary text-primary-foreground hover:bg-[#1e3d22] shadow-sm"
            >
              <Clock className="w-4 h-4 mr-1" strokeWidth={1.5} />
              Pedir cita
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};
